import React, { useEffect, useState } from "react";
import Icon from "../../components/HOC/Icon";
import { formatMoney } from "../../features/utils/formatMoney";
import CartSummary from "./CartSummary";
import Collapse from "../../components/mini/Collapse";
import getCart from "../../controllers/Cart/getCart";
import { useSelector } from "react-redux";
import moment from "moment";

export default function Cart() {
  const {userData: {user}} = useSelector(state => state.user)
  const [carts, setCarts] = useState([]);
  const [hotelCarts, sethotelCarts] = useState([]);
  const [tourCarts, settourCarts] = useState([]);
  let bookedCarts = [];


  useEffect(() => {
    async function load() {
      await loadCartById();
      loadCart();
      loadHotelCart();
      loadTourCart();
    }
    load();
  }, []);

  async function loadCartById() {
    const cartId = window.localStorage.getItem("cartId");
    if (!cartId) return true;
    const res = await getCart(cartId);
    if (res.return) {
      const data = res?.data?.populatedOrders || [];
      const bookings = data
        ?.map((obj) =>
          [obj?.flightBooking, obj?.hotelBooking, obj?.packageBooking].flat()
        )
        .flat();
      if (
        bookings?.map((obj) => obj.status)?.every((status) => status === "Paid")
      )
        bookedCarts = data?.map((obj) => obj?._id);
    }
  }

  function loadCart() {
    let carts = JSON.parse(window.localStorage.getItem("flightCart") || "[]");

    carts = carts?.filter((obj) => !bookedCarts.includes(obj?.booking?._id));
    window.localStorage.setItem("flightCart", JSON.stringify(carts));
    if (carts?.length === 0) window.localStorage.removeItem("cartId");
    setCarts(carts?.filter(obj => moment().diff(moment(obj?.booking?.flightBooking?.at(0)?.destinations?.at(-1)?.departureDate),'days') < 1 && (obj?.booking?.account || user?._id))?.map((obj) => templateFlightCart(obj)));
  }

  function loadHotelCart() {
    let hotelCarts = JSON.parse(window.localStorage.getItem("cart") || "[]");

    // Remove duplicates based on booking ID
    hotelCarts = hotelCarts.filter(
      (cart, index, self) =>
        index === self.findIndex((t) => t.booking?._id === cart.booking?._id)
    );

    // Filter out booked carts
    hotelCarts = hotelCarts?.filter(
      (obj) => !bookedCarts.includes(obj?.booking?._id)
    );

    window.localStorage.setItem("cart", JSON.stringify(hotelCarts));

    if (hotelCarts?.length === 0) {
      window.localStorage.removeItem("cartId");
    }

    sethotelCarts(hotelCarts?.map((obj) => templateHotelCart(obj)));
  }

  function loadTourCart() {

    let tourCarts = JSON.parse(window.localStorage.getItem("tourCart") || "[]");

    // Remove duplicates based on booking ID
    tourCarts = tourCarts.filter(
      (cart, index, self) =>
        index === self.findIndex((t) => t.booking?._id === cart.booking?._id)
    );

    // Filter out booked carts
    tourCarts = tourCarts?.filter(
      (obj) => !bookedCarts.includes(obj?.booking?._id)
    );

    window.localStorage.setItem("tourCart", JSON.stringify(tourCarts));

    if (tourCarts?.length === 0) {
      window.localStorage.removeItem("cartId");
    }

    settourCarts(tourCarts?.map((obj) => templateTourCart(obj)));
  }

  function handleRemove(id, type) {
    if (type === "Flight") {
      removeFlightFromCart(id);
    } else if (type === "Hotel") {
      removeHotelFromCart(id);
    } else if (type === "Tour") {
      removeTourFromCart(id);
    }
  }

  function removeFlightFromCart(id) {
    let tempCarts = JSON.parse(
      window.localStorage.getItem("flightCart") || "[]"
    );
    tempCarts = tempCarts?.filter((obj) => obj?.booking?._id !== id);
    window.localStorage.setItem("flightCart", JSON.stringify(tempCarts || []));
    loadCart();
  }

  function removeHotelFromCart(id) {
    let tempCarts = JSON.parse(window.localStorage.getItem("cart") || "[]");
    tempCarts = tempCarts?.filter((obj) => obj?.booking?._id !== id);
    window.localStorage.setItem("cart", JSON.stringify(tempCarts || []));
    loadHotelCart();
  }

  function removeTourFromCart(id) {
    let tempCarts = JSON.parse(window.localStorage.getItem("tourCart") || "[]");
    tempCarts = tempCarts?.filter((obj) => obj?.booking?._id !== id);
    window.localStorage.setItem("tourCart", JSON.stringify(tempCarts || []));
    loadTourCart();
  }

  // debugger
  return (
    <div className="flex flex-col gap-4 pd-md">
      <h5>Order Checkout</h5>
      {carts?.length ? (
        <div className="flex gap-4 flex-wrap">
          <div className="flex-1 flex flex-col gap-4">
            {carts.map((obj, i) => (
              <CartDisplay
                key={i}
                data={obj}
                remove={() => handleRemove(obj?.id, obj?.type)}
              />
            ))}
          </div>
          <div className="w-full sm:w-auto">
            <CartSummary data={carts} />
          </div>
        </div>
      ) : (
        <div className="flex justify-center py-10 items-center">
          No Flight Items
        </div>
      )}

      {hotelCarts?.length ? (
        <div className="flex gap-4 flex-wrap">
          <div className="flex-1 flex flex-col gap-4">
            {hotelCarts.map((obj, i) => (
              <CartDisplay
                key={i}
                data={obj}
                remove={() => handleRemove(obj?.id, obj?.type)}
              />
            ))}
          </div>
          <div className="w-full sm:w-auto">
            <CartSummary data={hotelCarts} />
          </div>
        </div>
      ) : (
        <div className="flex justify-center py-10 items-center">
          No Hotel Items
        </div>
      )}
    </div>
  );
}

export function templateFlightCart(obj) {
  // const departure = obj?.params?.offers
  //   ?.at(0)
  //   ?.directions?.at(0)
  //   ?.at(0)?.departure;
  // const airline = obj?.params?.offers?.at(0)?.directions?.at(0)?.at(0)?.airline;

  const flights = obj?.booking?.flightBooking?.at(0)?.flights;
  //  const airline = flights.;

  let data = {
    ...(obj||{}),
    price: obj?.booking?.flightBooking?.at(0)?.customerPayable|| 0,
    airline: {
      image: flights?.at(0)?.airlineImage,
      description: flights?.at(0)?.airlineName,
    },
    departureDate: flights?.at(0)?.departureDate + " " + flights?.at(0)?.departureTime,
    location: {
      from: flights?.at(0)?.departureLocationName,
      to: flights?.at(0)?.arrivalLocationName,
    },
    type: "Flight",
    id: obj?.booking?._id,
    detail: (
      <div className="flex flex-col gap-2">
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:person" className="!w-4 !h-4 text-primary/60" />
          {obj?.booking?.flightBooking?.at(0)?.travelers?.length} X Passenger
        </span>
        {flights
          ?.map((flight, index) => (
            <span key={index} className="flex gap-2 items-center">
              <Icon
                icon="mdi:seat-passenger"
                className="!w-4 !h-4 text-primary/60"
              />
              {flight?.seats?.length}x Seating ({flight?.departureLocation}{" "}
              - {flight?.arrivalLocation})
            </span>
          ))}
      </div>
    ),
  };

  return data;
}

function templateHotelCart(hotelCartData) {
  const {
    name = "Unknown Hotel",
    location = "London, UK",
    address = "Address Unavailable",
    start_date = "Check-in Not Set",
    end_date = "Check-out Not Set",
    city = "London",
    nights = "1",
    price = 0,
    images = [],
    bookingId = "",
    categoryCode = "",
    chainName = "",
  } = hotelCartData;

  return {
    price: parseFloat(price)?.toFixed(2) || "0.00",
    hotel: {
      name,
      address,
      image:
        Array.isArray(images) && images.length > 0
          ? images[0]
          : "/path/to/default-hotel-image.jpg",
      location: chainName || location,
    },
    dates: {
      checkIn: start_date,
      checkOut: end_date,
    },
    nights: parseInt(nights),
    type: "Hotel",
    id: bookingId,
    detail: (
      <div className="flex flex-col gap-2">
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:hotel" className="!w-4 !h-4 text-primary/60" />
          {name}
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:map-marker" className="!w-4 !h-4 text-primary/60" />
          {address}, {city}
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:calendar" className="!w-4 !h-4 text-primary/60" />
          {start_date} - {end_date} ({nights} night
          {parseInt(nights) !== 1 ? "s" : ""})
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:building" className="!w-4 !h-4 text-primary/60" />
          {categoryCode} - {chainName}
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:currency-usd" className="!w-4 !h-4 text-primary/60" />
          ${parseFloat(price)?.toFixed(2) || "0.00"}
        </span>
      </div>
    ),
  };
}

function templateTourCart(obj) {
  return {
    price: obj?.price || 0,
    tour: {
      name: obj?.tourName || "Unknown Tour",
      image: obj?.images?.[0] || "/path/to/default-tour-image.jpg",
      location: obj?.location || "Location not specified",
    },
    dates: {
      startDate: obj?.startDate || "Date not specified",
      endDate: obj?.endDate || "Date not specified",
    },
    duration: obj?.duration || 1,
    type: "Tour",
    id: obj?.booking?._id,
    detail: (
      <div className="flex flex-col gap-2">
        <span className="flex gap-2 items-center">
          <Icon
            icon="mdi:map-marker-path"
            className="!w-4 !h-4 text-primary/60"
          />
          {obj?.tourName}
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:map-marker" className="!w-4 !h-4 text-primary/60" />
          {obj?.location}
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:calendar" className="!w-4 !h-4 text-primary/60" />
          {obj?.startDate} - {obj?.endDate} ({obj?.duration} day
          {obj?.duration !== 1 ? "s" : ""})
        </span>
        <span className="flex gap-2 items-center">
          <Icon
            icon="mdi:account-group"
            className="!w-4 !h-4 text-primary/60"
          />
          {obj?.participants || 1} Participant
          {obj?.participants !== 1 ? "s" : ""}
        </span>
        <span className="flex gap-2 items-center">
          <Icon icon="mdi:currency-usd" className="!w-4 !h-4 text-primary/60" />
          ${parseFloat(obj?.price)?.toFixed(2) || "0.00"}
        </span>
      </div>
    ),
  };
}

function CartDisplay({ data, remove }) {
    const isHotel = data?.type === 'Hotel';
    const isTour = data?.type === 'Tour';

    return (
        <div className="border rounded-md p-5 shadow">
            <Collapse
                dropdown={null}
                label={
                    <div className="flex gap-2 w-full">
                        <button onClick={remove}>
                            <Icon
                                icon="material-symbols:delete-outline"
                                className="text-orange-300 hover:text-red-500"
                            />
                        </button>
                        <div className="flex-1 flex flex-col gap-1">
                            <b>
                                {isTour ? (
                                    <span>{data?.tour?.name || data?.tour?.location}</span>
                                ) : isHotel ? (
                                    <span>{data?.hotel?.name || data?.hotel?.location}</span>
                                ) : (
                                    <span>
                                        {data?.location?.from} to {data?.location?.to}
                                    </span>
                                )}
                            </b>
                            <div className="flex gap-4 items-center flex-wrap">
                                {isTour ? (
                                    <small className="flex gap-4">
                                        {data?.tour?.image && (
                                            <img
                                                src={data?.tour?.image}
                                                alt={data?.tour?.name}
                                                className="w-[130px] max-h-[40px] object-cover"
                                                onError={(e) => {
                                                    e.target.src = "/path/to/fallback-tour-image.jpg";
                                                    e.target.onerror = null;
                                                }}
                                            />
                                        )}
                                        <span>
                                            {data?.duration} day{data?.duration !== 1 ? "s" : ""}
                                        </span>
                                    </small>
                                ) : isHotel ? (
                                    <small className="flex gap-4">
                                        {data?.hotel?.image && (
                                            <img
                                                src={data?.hotel?.image}
                                                alt={data?.hotel?.name}
                                                className="w-[130px] max-h-[40px] object-cover"
                                                onError={(e) => {
                                                    e.target.src = "/path/to/fallback-hotel-image.jpg";
                                                    e.target.onerror = null;
                                                }}
                                            />
                                        )}
                                        <span>
                                            {data?.nights} night{data?.nights !== 1 ? "s" : ""}
                                        </span>
                                    </small>
                                ) : (
                                    <small className="flex gap-4">
                                        {data?.airline?.image && (
                                            <span>
                                                <img
                                                    alt={data?.airline?.description}
                                                    src={data?.airline?.image}
                                                    className="w-[130px] max-h-[40px] object-cover"
                                                    onError={(e) => {
                                                        e.target.src = "/path/to/fallback-airline-image.jpg";
                                                        e.target.onerror = null;
                                                    }}
                                                />
                                            </span>
                                        )}
                                        <span>{data?.departureDate}</span>
                                    </small>
                                )}
                            </div>
                        </div>
                        <b>{formatMoney(data.price)}</b>
                    </div>
                }
            >
                {data?.detail}
            </Collapse>
        </div>
    );
}
